import {createSlice} from "@reduxjs/toolkit";

const initialState = {
	report: null,
	mainTranslationsList: null,
	createTranslationsList: null,
	detailsTranslationsList: null,
	hoveredRow: null,
	editedRow: null,
	milestoneList: [],
	newMilestone: null,
	currentMilestone: null,
	addMilestone: false,
	documents: [],
	showUploadModal: false,
	packageMonitoringFilter: [],
	packageMonitoring: null,
	selected_packages: {},
	submitted_reports: []
};

export const procurementSlice = createSlice({
	name: "procurement",
	initialState,
	reducers: {
		setReport: (state, action) => {
			state.report = action.payload;
		},
		setMainTranslationsList: (state, action) => {
			state.mainTranslationsList = action.payload;
		},
		setCreateTranslationsList: (state, action) => {
			state.createTranslationsList = action.payload;
		},
		setDetailsTranslationsList: (state, action) => {
			state.detailsTranslationsList = action.payload;
		},
		setHoveredRow: (state, action) => {
			state.hoveredRow = action.payload
		},
		setEditedRow: (state, action) => {
			state.editedRow = action.payload
		},
		setMilestoneList: (state, action) => {
			state.milestoneList = action.payload
		},
		setNewMilestone: (state, action) => {
			if (!state.newMilestone) {
				state.newMilestone = action.payload
			} else {
				state.newMilestone = {...state.newMilestone, ...action.payload}
			}
		},
		setCurrentMilestone: (state, action) => {
			if (!state.currentMilestone) {
				state.currentMilestone = action.payload
			} else {
				state.currentMilestone = {...state.currentMilestone, ...action.payload}
			}
		},
		setAddMilestone: (state, action) => {
			state.addMilestone = action.payload
		},
		clearNewMilestone: (state, action) => {
			state.newMilestone = null;
		},
		setDocuments: (state, action) => {
			state.documents = action?.payload;
		},
		setShowUploadModal: (state, action) => {
			state.showUploadModal = action?.payload;
		},
		setPackageMonitoringFilter: (state, action) => {
			state.packageMonitoringFilter = action?.payload;
		},
		setPackageMonitoring: (state, action) => {
			state.packageMonitoring = action?.payload;
		},
		setSelectedPackages: (state, action) => {
			state.selected_packages = action?.payload;
		},
		setSubmittedReports: (state, action) => {
			state.submitted_reports = action?.payload;
		},
	},
});

export const {
	setReport,
	setMainTranslationsList,
	setCreateTranslationsList,
	setDetailsTranslationsList,
	setEditedRow,
	setHoveredRow,
	setMilestoneList,
	setNewMilestone,
	setCurrentMilestone,
	setAddMilestone,
	clearNewMilestone,
	setDocuments,
	setShowUploadModal,
	setPackageMonitoringFilter,
	setPackageMonitoring,
	setSelectedPackages,
	setSubmittedReports
} = procurementSlice.actions;

export default procurementSlice.reducer;
